/**
 * Nomenclature table registry — mirrors the mobile app's azure_* sync tables.
 *
 * Each entry maps:
 *  - `store`    : the Dexie/IndexedDB store name
 *  - `hashKey`  : the key under which the server reports this table's hash in
 *                 `GET /mobile/azure/sync-hashes`
 *  - `endpoint` : the backend path that returns the rows (`{ data: [...] }`)
 *  - `schema`   : Dexie index declaration — `id` primary key + the foreign-key
 *                 fields we filter on (these stay in CLEAR for indexing)
 *  - `encrypt`  : sensitive fields moved into an encrypted `_enc` blob at rest
 *                 (PII / pricing). Everything else is stored as-is.
 */
export interface NomenclatureTable {
  store: string;
  hashKey: string;
  endpoint: string;
  schema: string;
  encrypt: string[];
}

export const TABLES: NomenclatureTable[] = [
  { store: 'cities', hashKey: 'cities', endpoint: '/mobile/azure/cities', schema: 'id', encrypt: [] },
  { store: 'azure_degrees', hashKey: 'azure_degrees', endpoint: '/mobile/azure/degrees', schema: 'id, degree_id', encrypt: [] },
  { store: 'azure_specialties', hashKey: 'azure_specialties', endpoint: '/mobile/azure/specialties', schema: 'id, specialty_id, medis_specialization_id', encrypt: [] },
  { store: 'azure_locations', hashKey: 'azure_locations', endpoint: '/mobile/azure/locations', schema: 'id, location_id, medis_location_id, city_id, is_active', encrypt: ['address', 'phone1', 'phone2'] },
  { store: 'azure_physicians', hashKey: 'azure_physicians', endpoint: '/mobile/azure/physicians', schema: 'id, master_physician_id, is_active', encrypt: ['last_name', 'first_name', 'full_name'] },
  { store: 'azure_physician_entities', hashKey: 'azure_physician_entities', endpoint: '/mobile/azure/physician-entities', schema: 'id, physician_id, entity_id, specialty_id, location_id', encrypt: [] },
  { store: 'azure_physician_roles', hashKey: 'azure_physician_roles', endpoint: '/mobile/azure/physician-roles', schema: 'id, physician_id, degree_id, specialty_id', encrypt: [] },
  { store: 'azure_physician_prices', hashKey: 'azure_physician_prices', endpoint: '/mobile/azure/physician-prices', schema: 'id, physician_id, entity_id, specialty_id, location_id, inv_id', encrypt: ['price'] },
  { store: 'azure_physician_timetables', hashKey: 'azure_physician_timetables', endpoint: '/mobile/azure/physician-timetables', schema: 'id, physician_id, location_id, specialty_id, day_of_week', encrypt: [] },
  { store: 'azure_investigation_types', hashKey: 'azure_investigation_types', endpoint: '/mobile/azure/investigation-types', schema: 'id, type_id', encrypt: [] },
  { store: 'azure_investigations', hashKey: 'azure_investigations', endpoint: '/mobile/azure/investigations', schema: 'id, inv_id, type_id, is_active', encrypt: [] },
  { store: 'azure_filter_combinations', hashKey: 'azure_filter_combinations', endpoint: '/mobile/azure/filter-combinations', schema: 'id, city_id, location_id, specialty_id, physician_id, entity_id, investigation_id', encrypt: ['price'] },
];

/** Tables required before the appointment-creation wizard can run (mobile parity). */
export const APPOINTMENT_TABLES = [
  'cities',
  'azure_degrees',
  'azure_specialties',
  'azure_locations',
  'azure_physicians',
  'azure_physician_entities',
  'azure_physician_roles',
  'azure_physician_prices',
  'azure_physician_timetables',
];
